import { merge, omit } from 'lodash-es'
import { extendObservable, observable, toJS } from 'mobx'
import { LanguageISO } from 'utils/localisation'

import { Role } from '../roles'

export class UserStore {
  @observable
  // @ts-expect-error TS(2564) FIXME: Property '_id' has no initializer and is not defin... Remove this comment to see the full error message
  _id: string
  @observable
  salutation?: string
  @observable
  title?: string
  @observable
  languages?: LanguageISO[]
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'email' has no initializer and is not def... Remove this comment to see the full error message
  email: string
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'firstName' has no initializer and is not... Remove this comment to see the full error message
  firstName: string
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'lastName' has no initializer and is not ... Remove this comment to see the full error message
  lastName: string
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'phoneLandline' has no initializer and is... Remove this comment to see the full error message
  phoneLandline: string
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'phoneMobile' has no initializer and is n... Remove this comment to see the full error message
  phoneMobile: string
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'newsletter' has no initializer and is no... Remove this comment to see the full error message
  newsletter: boolean
  @observable
  // @ts-expect-error TS(2564) FIXME: Property 'preferredLanguage' has no initializer an... Remove this comment to see the full error message
  preferredLanguage: LanguageISO
  @observable
  registeredAt?: Date
  @observable
  roles?: Role[]
  // @ts-expect-error TS(2564) FIXME: Property 'customer_id' has no initializer and is n... Remove this comment to see the full error message
  customer_id: string
  // @ts-expect-error TS(2564) FIXME: Property 'organizationId' has no initializer and i... Remove this comment to see the full error message
  organizationId: string
  // @ts-expect-error TS(2564) FIXME: Property 'lastLogin' has no initializer and is not... Remove this comment to see the full error message
  lastLogin: Date

  constructor(userJSON) {
    this.fromJSON(userJSON)
  }

  fromJSON(userJSON) {
    extendObservable(this, merge({}, userJSON))
  }

  toJSON() {
    // omit this in order to not overwrite the UserDetailsStore toJSON function.
    // This problem occurs if we transpile to ES5, but if we transpile to ES6 we can do it without the omit
    return toJS(omit(this, ['fromJSON', 'toJSON']))
  }
}
